export default "/images/1dedadd9993588ace27c41bbe9e8d59c.png";